import { EventEmitter } from '@angular/core';
import { MatDialogRef, MatDialog, MatSnackBar } from '@angular/material';
import { ExerciseService } from 'app/shared/services/exercises.service';
import { Program } from '../../../shared/models/Program';
import { MpDialogComponent } from '../mp-dialog/mp-dialog.component';
import { Exercise } from '../../../shared/models/Exercises';
import { TranslateService } from '@ngx-translate/core';
var AddDialogComponent = (function () {
    function AddDialogComponent(exerciseService, dialog, snackBar, translate, dialogRef, data) {
        var _this = this;
        this.exerciseService = exerciseService;
        this.dialog = dialog;
        this.snackBar = snackBar;
        this.translate = translate;
        this.dialogRef = dialogRef;
        this.data = data;
        this.onSelect = new EventEmitter();
        this.newProgramTitle = '';
        if (data && data.exerciseID) {
            this.addExercise = data.exerciseID;
        }
        this.exerciseService.getMyPrograms().then(function (programs) {
            _this.favs = programs.filter(function (prog) {
                return prog.exerciseIds.length < 3 && !prog.exercises.includes(_this.addExercise);
            });
            translate
                .get('EXERCISES.EDITOR.defaultProgramTitle', { number: _this.favs.length + 1 })
                .subscribe(function (res) {
                _this.newProgramTitle = res;
            });
        });
    }
    AddDialogComponent.prototype.closeAddDialog = function () {
        this.onSelect.emit();
        this.closeDialog();
    };
    AddDialogComponent.prototype.closeDialog = function (result) {
        this.dialogRef.close(result);
    };
    AddDialogComponent.prototype.openMpDialog = function (editProgram) {
        var dialogRef = this.dialog.open(MpDialogComponent, {
            panelClass: 'app-MP-dialog-container',
            // width: '90vw',
            // height: '98vh',
            position: {
                top: '2vh',
            },
            data: editProgram || {},
        });
        dialogRef.afterClosed().subscribe(function (result) { });
    };
    AddDialogComponent.prototype.addToProgram = function (editProgram) {
        var _this = this;
        if (editProgram) {
            editProgram.exerciseIds.push(this.addExercise._id);
            editProgram.exercises.push(this.addExercise);
            this.exerciseService
                .updateMyProgram(editProgram)
                .then(function (result) {
                _this.translate.get('EXERCISES.EDITOR.ALERT.addedToProgram', editProgram).subscribe(function (message) {
                    var snackBarRef = _this.snackBar.open(message, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-success', 'top'],
                    });
                    _this.closeAddDialog();
                });
            })
                .catch(function (error) {
                _this.translate.get('EXERCISES.EDITOR.ALERT.addToProgramError', editProgram).subscribe(function (message) {
                    var snackBarRef = _this.snackBar.open(message, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            });
        }
        else {
            editProgram = new Program();
            editProgram.exerciseIds = [this.addExercise._id];
            editProgram.exercises = [this.addExercise];
            editProgram.title = this.newProgramTitle;
            editProgram.previewUrl = this.addExercise.previewUrl;
            this.exerciseService
                .saveNewProgram(editProgram)
                .then(function (result) {
                _this.translate.get('EXERCISES.EDITOR.ALERT.addedToNewProgram', editProgram).subscribe(function (message) {
                    var snackBarRef = _this.snackBar.open(message, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-success', 'top'],
                    });
                    _this.closeAddDialog();
                });
            })
                .catch(function (error) {
                _this.translate.get('EXERCISES.EDITOR.ALERT.addToProgramError', editProgram).subscribe(function (message) {
                    var snackBarRef = _this.snackBar.open(message, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
            });
        }
    };
    return AddDialogComponent;
}());
export { AddDialogComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/add-dialog/add-dialog.component.ts.pre-build-optimizer.js